/* Ranzen Kids — Hero Slider (vanilla JS, no dependencies) */
(function () {
  function initSlider(section) {
    var track  = section.querySelector('.rz-hero__track');
    var slides = section.querySelectorAll('.rz-slide');
    var dots   = section.querySelectorAll('.rz-dot');
    if (!track || slides.length < 2) return;

    var current   = 0;
    var autoTimer = null;
    var interval  = parseInt(section.dataset.interval || '5000', 10);

    function goTo(idx) {
      slides[current].setAttribute('aria-hidden', 'true');
      dots[current] && dots[current].classList.remove('rz-dot--active');
      dots[current] && dots[current].setAttribute('aria-selected', 'false');

      current = (idx + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      slides[current].setAttribute('aria-hidden', 'false');
      dots[current] && dots[current].classList.add('rz-dot--active');
      dots[current] && dots[current].setAttribute('aria-selected', 'true');
    }

    function startAuto() {
      if (interval <= 0) return;
      autoTimer = setInterval(function () { goTo(current + 1); }, interval);
    }

    function stopAuto() {
      clearInterval(autoTimer);
    }

    section.querySelectorAll('.rz-hero__arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        stopAuto();
        goTo(current + (btn.dataset.dir === 'next' ? 1 : -1));
        startAuto();
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopAuto();
        goTo(i);
        startAuto();
      });
    });

    var arrows = section.querySelectorAll('.rz-hero__arrow');
    var arrowHideTimer = null;

    function showArrows() {
      clearTimeout(arrowHideTimer);
      arrows.forEach(function (a) { a.classList.add('is-visible'); });
    }

    function scheduleHideArrows() {
      clearTimeout(arrowHideTimer);
      arrowHideTimer = setTimeout(function () {
        arrows.forEach(function (a) { a.classList.remove('is-visible'); });
      }, 2500);
    }

    /* Pause on hover + show arrows */
    section.addEventListener('mouseenter', function () { stopAuto(); showArrows(); });
    section.addEventListener('mouseleave', function () { startAuto(); scheduleHideArrows(); });

       /* Touch swipe */
    var touchStartX = 0;
    var didSwipe = false;
    section.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      didSwipe = false;
    }, { passive: true });
    section.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        didSwipe = true;
        stopAuto();
        goTo(current + (diff > 0 ? 1 : -1));
        startAuto();
      }
    }, { passive: true });

    /* Prevent the swipe gesture from also triggering the slide's link */
    slides.forEach(function (slide) {
      slide.addEventListener('click', function (e) {
        if (didSwipe) e.preventDefault();
      });
    });

    startAuto();
  }

  function init() {
    document.querySelectorAll('.rz-hero').forEach(initSlider);
  }

  /* Shopify theme editor support */
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.rz-hero');
    if (section) initSlider(section);
  });
})();
